// extracted by mini-css-extract-plugin
module.exports = {"navItem":"NavLinks_navItem__31lJM","mobileMenuItem":"NavLinks_mobileMenuItem__2tpMU"};